export const validateAddModal = (vm) => {
  if (!vm.name || vm.name.length < 2) {
    return {
      isValid: false,
      message: "Hesap Adı en az 2 karakter olmalıdır.",
    };
  }

  if (vm.fillingPoint.lat === 0 || vm.fillingPoint.lng === 0 || vm.deliveryPoint.lat === 0 || vm.deliveryPoint.lng === 0) {
    return {
      isValid: false,
      message: "Lütfen Başlangıç ve Bitiş Noktalarını seçiniz.",
    };
  }

  const numericTotalPrice = parseFloat(String(vm.totalPrice).replace(",", "."));
  const numericTonnagePrice = parseFloat(vm.tonnagePrice);

  if (numericTotalPrice < numericTonnagePrice && (!vm.explanation || vm.explanation.trim().length === 0)) {
    return {
      isValid: false,
      message: "Ton maliyetinin altında bir Satış Fiyatı girildi. Lütfen açıklamanızı Not alanına ekleyin.",
    };
  }

  return {
    isValid: true,
    message: "",
  };
};
